import { Nullable } from '@dxb-web-ui-framework/common/types';
import { CreditAccountTypes } from '../types';

class FavouriteTransfer {
  name: string;
  id: number;
  shared: boolean;
  owned: boolean;
  debitAccountNumber: string;
  creditAccountNumber: string;
  orderCurrency: number;
  currencyDescription: string;
  orderAmount: number;
  creditAccountType: CreditAccountTypes;
  receiverComments: string;
  receiverBic: string;
  receiverAddress: string;
  receiverFullName: string;
  receiverFullNameMasked: string;
  chargingMethod: number;
  chargingMethodDescription: string;
  countrySn: number;
  bankCountrySn: number;
  countryDescription: string;
  countryShortDescription: string;
  additionalGlobalOrdersDetailBicBankCode: string;
  additionalGlobalOrdersDetailInnTaxPayerCode: string;
  additionalGlobalOrdersDetailCorCbr: number;
  additionalGlobalOrdersDetailKppBeneficiary: string;
  additionalGlobalOrdersDetailVocGhCode: string;
  additionalGlobalOrdersDetailVocGdCode: number;
  additionalGlobalOrdersDetailBopGh: string;
  additionalGlobalOrdersDetailBopGd: number;
  receiverSortCode: string;
  bankName: string;
  receiverCity: string;
  priorityDate?: Nullable<string>;

  constructor(
    name: string,
    id: number,
    shared: boolean,
    owned: boolean,
    debitAccountNumber: string,
    creditAccountNumber: string,
    orderCurrency: number,
    currencyDescription: string,
    orderAmount: number,
    creditAccountType: CreditAccountTypes,
    receiverComments: string,
    receiverBic: string,
    receiverAddress: string,
    receiverFullName: string,
    receiverFullNameMasked: string,
    chargingMethod: number,
    chargingMethodDescription: string,
    countrySn: number,
    bankCountrySn: number,
    countryDescription: string,
    countryShortDescription: string,
    additionalGlobalOrdersDetailBicBankCode: string,
    additionalGlobalOrdersDetailInnTaxPayerCode: string,
    additionalGlobalOrdersDetailCorCbr: number,
    additionalGlobalOrdersDetailKppBeneficiary: string,
    additionalGlobalOrdersDetailVocGhCode: string,
    additionalGlobalOrdersDetailVocGdCode: number,
    additionalGlobalOrdersDetailBopGh: string,
    additionalGlobalOrdersDetailBopGd: number,
    receiverSortCode: string,
    bankName: string,
    receiverCity: string,
    priorityDate?: Nullable<string>,
  ) {
    this.name = name;
    this.id = id;
    this.shared = shared;
    this.owned = owned;
    this.debitAccountNumber = debitAccountNumber;
    this.creditAccountNumber = creditAccountNumber;
    this.orderCurrency = orderCurrency;
    this.currencyDescription = currencyDescription;
    this.orderAmount = orderAmount;
    this.creditAccountType = creditAccountType;
    this.receiverComments = receiverComments;
    this.receiverBic = receiverBic;
    this.receiverAddress = receiverAddress;
    this.receiverFullName = receiverFullName;
    this.receiverFullNameMasked = receiverFullNameMasked;
    this.chargingMethod = chargingMethod;
    this.chargingMethodDescription = chargingMethodDescription;
    this.countrySn = countrySn;
    this.bankCountrySn = bankCountrySn;
    this.countryDescription = countryDescription;
    this.countryShortDescription = countryShortDescription;
    this.additionalGlobalOrdersDetailBicBankCode = additionalGlobalOrdersDetailBicBankCode;
    this.additionalGlobalOrdersDetailInnTaxPayerCode = additionalGlobalOrdersDetailInnTaxPayerCode;
    this.additionalGlobalOrdersDetailCorCbr = additionalGlobalOrdersDetailCorCbr;
    this.additionalGlobalOrdersDetailKppBeneficiary = additionalGlobalOrdersDetailKppBeneficiary;
    this.additionalGlobalOrdersDetailVocGhCode = additionalGlobalOrdersDetailVocGhCode;
    this.additionalGlobalOrdersDetailVocGdCode = additionalGlobalOrdersDetailVocGdCode;
    this.additionalGlobalOrdersDetailBopGh = additionalGlobalOrdersDetailBopGh;
    this.additionalGlobalOrdersDetailBopGd = additionalGlobalOrdersDetailBopGd;
    this.receiverSortCode = receiverSortCode;
    this.bankName = bankName;
    this.receiverCity = receiverCity;
    this.priorityDate = priorityDate;
  }
}

export { FavouriteTransfer };
